import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from '@/components/common/Select/Select';
import { IOptions } from '@/data/models/option';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  packagings: IOptions<string>[];
  loadPackaging: (inputText: string | null, callback: any) => void;
  handlePackaging: (value: any) => void;
};

export default function PackagingFormGroup({
  album,
  readonly,
  disabled,
  packagings,
  loadPackaging,
  showValidationErrors,
  fieldHasErrors,
  findErrorMessage,
  handlePackaging,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      {packagings.length > 0 && (
        <Select
          id="packagingTypeahead"
          labelTitle={t('product.editProduct.packaging')}
          labelClass="col-sm-3 form-label"
          isClearable={!readonly}
          loadOptions={loadPackaging}
          placeholder=""
          onChange={(e: any) => handlePackaging(e)}
          initialOption={packagings.find(
            (p) => p.label === album.packaging?.name
          )}
          className="col-sm-6"
          isDisabled={disabled}
          isReadOnly={readonly}
          hasErrors={fieldHasErrors('Packaging')}
          errorMessage={findErrorMessage('Packaging')}
          isRequired={true}
          showValidationErrors={showValidationErrors}
          fieldValidationKey={'productEditMode.Packaging'}
        />
      )}
    </div>
  );
}
